import { useEffect } from 'react'
import { useAppContext } from '../contexts/AppContext'

export default function useAccentColorUpdate() {
  const {
    rootRef,
    settings: { accentColor, theme },
  } = useAppContext()

  useEffect(() => {
    if (!rootRef.current) return

    rootRef.current.style.setProperty('--color-ac-accent', accentColor || '')
  }, [accentColor, theme])
}
